import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchErrors } from '../actions/error_management'
import { createUser } from '../actions/users'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import AddUserComponent from '../components/users/add_user'

class AddUser extends PureComponent {
  state = {
    errors: {},
    errorDetails: [],
  }
  createUser = async (user) => {
    this.setState({ errorDetails: [], errors: {} })
    const { error, details } = await this.props.createUser(user)
    if (error && details) {
      if (Array.isArray(details)) {
        this.setState({ errorDetails: details })
      } else {
        this.setState({ errors: details })
      }
    } else {
      this.props.history.push('/users')
    }
  }
  render() {
    const { state, props } = this
    const { errorMessage } = props
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-9 col-sm-9'>
              <h2>Add User</h2>
            </div>
            <div className='col-xs-3 col-sm-3 text-end'>
              <Button bsPrefix='btn btn-w-m btn-default' onClick={() => props.history.push('/users')}>
                <i className='fa fa-arrow-left' /> Back
              </Button>
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <AddUserComponent
            createUser={this.createUser}
            history={props.history}
            errors={state.errors}
            errorDetails={state.errorDetails}
            errorMessage={errorMessage}
          />
          <div />
        </DivContentBox>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.createUser.errorMessage,
  errors: state.createUser.errors,
  results: state.createUser.results,
  isFetching: state.createUser.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createUser,
      fetchErrors,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddUser))
